import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { z } from "zod"

export const CoachDtoSchema = z
  .object({
    id: z.string(),
    username: z.string(),
    firstname: z.string(),
    lastname: z.string(),
    avatar: HUImageDtoSchema.nullable(),
    stripeAccountInError: z.boolean(),
  })
  .meta({ id: "CoachDtoSchema" })

export type CoachDto = z.infer<typeof CoachDtoSchema>
